import React from 'react';
import UserAvatar from '../../components/settings/user/UserAvatar';
import UserPassword from '../../components/settings/user/UserPassword';
import UserProfile from '../../components/settings/user/UserProfile';
import { ButtonFilled, ScrollView } from '../../components/ui';
import { logout } from '../../lib/auth';

const UserAccountPage = () => {
  return (
    <ScrollView className="ph2">
      <div
        className="w-100 mw8 center pb5 pt5"
        style={{
          maxWidth: 695
        }}
      >
        <UserProfile />
        <UserAvatar />
        <UserPassword />
        <ButtonFilled data-testid="logout-button" onClick={logout}>
          Log Out
        </ButtonFilled>
      </div>
    </ScrollView>
  );
};

export default UserAccountPage;
